var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('button',_vm._g({staticClass:"btn",class:_vm.btnClass},_vm.$listeners),[_c('span',{staticClass:"profile-icon material-icons l-blue"},[_vm._v(" edit_document ")]),_c('span',{staticClass:"profile-button-text"},[_vm._v("プロフィール")])])}
var staticRenderFns = []

export { render, staticRenderFns }